import React, { useEffect } from "react";
import classes from "./Syvi.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, {Feature, Topic} from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.svg";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import { ECaseStudy } from "../../../enums/case-study.enum.ts";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";
import { useTranslation } from "react-i18next";


const Syvi = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = [t('syvi.title'), t('syvi.blueTitle')]

    const description = t('syvi.text', {returnObjects: true})
    

    const infoTitle = t('syvi.info.title');

    const infoTitleMessage = t('syvi.info.text')
    const topics: Topic[] = t('syvi.topic', {returnObjects: true})

    const features: Feature = {
        title: t('syvi.featuresText'),
        extendedList: t('syvi.featuresList', {returnObjects: true})
    }

    const results = {
        title: t('syvi.results.title'),
        ul: t('syvi.results.ul', {returnObjects: true})
    }

    const rightBlock = {
    platforms: t('syvi.rightBlock.platforms', {returnObjects: true}),
    services: t('syvi.rightBlock.services', {returnObjects: true}),
    audience: t('syvi.rightBlock.audience', {returnObjects: true}),
    field: t('syvi.rightBlock.field', {returnObjects: true})
    }


    return (
        <>
            <OrganizationSeo
                title="Goteco: Secure and Scalable GovTech and Business Solutions"
                description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
                url="https://go-te.co/"
                image="https://go-te.co/logo.svg"
            />

            <section className={classes.section} id="nav-dark">
                <Heading title={title} description={description} maxWidth={640} imageName={'syvi.webp'} imageHeight={203} imageWidth={306} buttonText={t('syvi.buttonText')} href={"https://www.syvi.com.ua/"}/>
                <Info title={infoTitle} titleMessage={infoTitleMessage} topics={topics} features={features} rightBlock={rightBlock} results={results}/>

                <div className={classes["image-section"]}>
                    <div className={classes["overlay"]}></div>
                    <div className={classes["image-container"]}>
                        <img className={classes.logo} src={logo} alt="Cybertracker logo" />
                        <div className={classes.text}>
                            {t('syvi.bottomText')}
                            <span>{t('syvi.bottomText2')}</span>
                        </div>
                    </div>
                </div>

                <OtherProjects name={ECaseStudy.SYVI} />
            </section>
        </>

    );
};

export default Syvi;
